'use client';

import getCDNURL from '@pickleballinc/ui/components/global/utils/getCDNURL';
import Link from 'next/link';

import { MarketingModuleItemDto } from '@/infrastructure/network/dto/HpMarketingModuleDto';

interface BaseMarketingSectionProps {
	marketingData: MarketingModuleItemDto[];
	marketingTitle: string;
	className?: string;
}

export const BaseMarketingSection = ({ marketingData, marketingTitle, className }: BaseMarketingSectionProps) => {
	return (
		<div className={`py-8 odd:bg-white even:bg-gray-50 ${className}`}>
			<div className="mx-auto flex max-w-screen-2xl flex-row items-baseline justify-between p-4">
				<h1 className="text-2xl font-semibold text-gray-900">{marketingTitle}</h1>
			</div>
			<div className="mx-auto grid max-w-screen-2xl grid-cols-3 gap-4 p-4 md:gap-10 lg:grid-cols-5 xl:grid-cols-7">
				{marketingData?.map((item: MarketingModuleItemDto) => (
					<div className="relative h-32 w-full rounded-lg border bg-white" key={item.uuid}>
						<Link href={item.websiteUrl ?? '#'} target="_blank" prefetch={false}>
							<img
								src={
									item.logo
										? getCDNURL(item.logo.url, 188 * 2, 126 * 2)
										: `${process.env.NEXT_PUBLIC_IMAGE_CDN}/placeholder/pickleball_transparent_square.png`
								}
								alt="Marketing Logo"
								className="absolute inset-0 size-full rounded-lg object-contain p-2"
							/>
						</Link>
					</div>
				))}
			</div>
		</div>
	);
};
